/**
 * This utility function generates unique names for windows. It solves the problem of collision of names and context hijacking
 * The implementation is recommended there: https://git.hubteam.com/HubSpot/PaymentsAcquisitionPlanning/issues/1070
 */
export function generateUniqueWindowName(prefix = 'oauth-window') {
  const timestamp = Date.now();
  const randomId = crypto.getRandomValues ? crypto.getRandomValues(new Uint32Array(1))[0] : Math.floor(Math.random() * 0xffffffff);
  return `${prefix}-${timestamp}-${randomId}`;
}
export function openPopup(url) {
  const width = Math.min(800, window.screen.width - 100);
  const height = 600;
  const left = window.screen.width / 2 - width / 2;
  const top = 100;
  const options = `width=${width},height=${height},menubar=0,screenY=${top},screenX=${left},scrollbars=1,resizable=1`;
  const popup = window.open(url, generateUniqueWindowName(), options);
  try {
    popup === null || popup === void 0 || popup.focus();
  } catch (e) {
    // This is not supported in all browsers, but there's no harm in trying it. This just squashes Sentries.
  }
  return popup;
}
export function openTab(url) {
  const tab = window.open(url, generateUniqueWindowName());
  try {
    tab === null || tab === void 0 || tab.focus();
  } catch (e) {
    // This is not supported in all browsers, but there's no harm in trying it. This just squashes Sentries.
  }
  return tab;
}
export function openNewWindow(url) {
  return window.open(url, '_blank', 'noopener,noreferrer');
}